import { FirebaseActionTypes, FirebaseActions, FirebaseTypes } from '@web_opxp/features';
import { ActionCreator } from 'redux';

/**
 * firebase analytics action builders
 */

// top button clicked action
export const firebaseTopButtonEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_button_start',
  parameters: [
    {
      key: 'button_clicked',
      value: 'top button',
    },
  ],
};
export const firebaseTopButtonClickAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  return FirebaseActions.analyticsEventAction(firebaseTopButtonEventPayload);
};

// get started clicked action
export const firebaseGetStartedEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_button_start',
  parameters: [
    {
      key: 'button_clicked',
      value: 'get started',
    },
  ],
};
export const firebaseGetStartedClickAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  return FirebaseActions.analyticsEventAction(firebaseGetStartedEventPayload);
};

// learn more clicked action
export const firebaseLearnMoreEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_button_start',
  parameters: [
    {
      key: 'button_clicked',
      value: 'learn more',
    },
  ],
};
export const firebaseLearnMoreClickAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  return FirebaseActions.analyticsEventAction(firebaseLearnMoreEventPayload);
};

// start introduction video clicked action
export const firebaseStartIntroEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_trigger',
  parameters: [
    {
      key: 'location',
      value: 'start',
    },
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebaseStartIntroClickAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  return FirebaseActions.analyticsEventAction(firebaseStartIntroEventPayload);
};

// skip introduction video clicked action
export const firebaseSkipIntroEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_trigger',
  parameters: [
    {
      key: 'location',
      value: 'skip',
    },
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebaseSkipIntroClickAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  return FirebaseActions.analyticsEventAction(firebaseSkipIntroEventPayload);
};

// play introduction video clicked action
export const firebasePlayIntroEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_trigger',
  parameters: [
    {
      key: 'location',
      value: 'play',
    },
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebasePlayIntroClickAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  return FirebaseActions.analyticsEventAction(firebasePlayIntroEventPayload);
};

// on introduction video started action
export const firebaseOnIntroStartedEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_started',
  parameters: [
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebaseOnIntroStartedAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  return FirebaseActions.analyticsEventAction(firebaseOnIntroStartedEventPayload);
};

// on introduction video close action
export const firebaseOnIntroCloseEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_close',
  parameters: [
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebaseOnIntroCloseAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  return FirebaseActions.analyticsEventAction(firebaseOnIntroCloseEventPayload);
};

// on introduction video completed action
export const firebaseOnIntroCompletedEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'o_video_completed',
  parameters: [
    {
      key: 'video_ID',
      value: '1',
    },
  ],
};
export const firebaseOnIntroCompletedAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  return FirebaseActions.analyticsEventAction(firebaseOnIntroCompletedEventPayload);
};
